import { render, staticRenderFns } from "./RiskStats.vue?vue&type=template&id=0d98eb78&scoped=true&"
import script from "./RiskStats.vue?vue&type=script&lang=ts&"
export * from "./RiskStats.vue?vue&type=script&lang=ts&"
import style0 from "./RiskStats.vue?vue&type=style&index=0&id=0d98eb78&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d98eb78",
  null
  
)

export default component.exports